import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useToast } from '../context/ToastContext';
import { authApi } from '../services/api';

const VerifyEmail = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const { addToast } = useToast();
    const [status, setStatus] = useState('verifying'); // 'verifying', 'success', 'error'
    const [message, setMessage] = useState('');

    useEffect(() => {
        const verifyEmailToken = async () => {
            const token = searchParams.get('token');
            const email = searchParams.get('email');

            if (!token || !email) {
                setStatus('error');
                setMessage('Invalid verification link. Please request a new verification email.');
                return;
            }

            try {
                const response = await authApi.verifyEmail(token, email);
                
                if (response.message) {
                    setStatus('success');
                    setMessage('Email verified successfully! You can now log in.');
                    addToast('Email verified successfully!', 'success', 6000);
                    setTimeout(() => {
                        navigate('/login');
                    }, 2000);
                }
            } catch (error) {
                setStatus('error');
                const errorMessage = error?.error || error?.message || 'Failed to verify email. The link may have expired.';
                setMessage(errorMessage);
                addToast(errorMessage, 'error', 8000);
            }
        };

        verifyEmailToken();
    }, [searchParams, navigate, addToast]);

    return (
        <div className="flex items-center justify-center min-h-screen bg-black text-white" style={{ marginTop: '-96px' }}>
            <div className="bg-black p-8 rounded-lg shadow-md w-96 text-center">
                {status === 'verifying' && (
                    <>
                        <div className="mb-4">
                            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-lime-400 mx-auto"></div>
                        </div>
                        <h2 className="text-2xl font-semibold mb-4">Verifying Email</h2>
                        <p>Please wait while we verify your email address...</p>
                    </>
                )}

                {status === 'success' && (
                    <>
                        <div className="mb-4">
                            <svg className="w-16 h-16 text-lime-400 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                            </svg>
                        </div>
                        <h2 className="text-2xl font-semibold mb-4 text-lime-400">Email Verified!</h2>
                        <p className="mb-4">{message}</p>
                        <p className="text-sm text-gray-400">Redirecting to login...</p>
                    </>
                )}

                {status === 'error' && (
                    <>
                        <div className="mb-4">
                            <svg className="w-16 h-16 text-red-500 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </div>
                        <h2 className="text-2xl font-semibold mb-4 text-red-500">Verification Failed</h2>
                        <p className="mb-6 text-gray-300">{message}</p>
                        <button
                            onClick={() => {
                                const email = searchParams.get('email');
                                if (email) {
                                    navigate('/check-your-email', { state: { email } });
                                } else {
                                    navigate('/register');
                                }
                            }}
                            className="w-full p-2 bg-lime-400 text-black rounded hover:bg-lime-500 transition-colors"
                        >
                            Request New Verification Link
                        </button>
                        <button
                            onClick={() => navigate('/login')}
                            className="w-full mt-2 p-2 bg-gray-700 text-white rounded hover:bg-gray-600 transition-colors"
                        >
                            Back to Login
                        </button>
                    </>
                )}
            </div>
        </div>
    );
};

export default VerifyEmail;

